import React from 'react';
import { BrowserRouter, Route, Routes } from "react-router";
import Home from './Pages/Home';

const RoutesUrls = () => {
    return ( 
        <BrowserRouter>
            <Routes>
                <Route path='/' element={<Home />}/>
            </Routes>
        </BrowserRouter>
     );
}
 
export default RoutesUrls;